// extracted by mini-css-extract-plugin
module.exports = {"container":"organizationOverview_container__1iiHT","spacer":"organizationOverview_spacer__3TCXM"};